import ApiService from '@shared/services/api.service';

const ENGINE_CACHE_TTL_MS = 5 * 60 * 1000;
const engineCache = new Map();
const engineRequests = new Map();

function clearEngineCache() {
  engineCache.clear();
}

const RenderingService = {
  listFqdns() {
    return ApiService.get('/fqdns');
  },

  getCustomerConfig() {
    return ApiService.get('/rendering_customer_config');
  },

  upsertCustomerConfig(body) {
    return ApiService.put('/rendering_customer_config', body);
  },

  deleteCustomerConfig() {
    return ApiService.delete('/rendering_customer_config');
  },

  getFqdnConfig(fqdnId) {
    return ApiService.get(`/fqdns/${fqdnId}/rendering_config`);
  },

  upsertFqdnConfig(fqdnId, body) {
    return ApiService.put(`/fqdns/${fqdnId}/rendering_config`, body);
  },

  deleteFqdnConfig(fqdnId) {
    return ApiService.delete(`/fqdns/${fqdnId}/rendering_config`);
  },

  getUrlConfig(urlId) {
    return ApiService.get(`/urls/${urlId}/rendering_config`);
  },

  upsertUrlConfig(urlId, body) {
    return ApiService.put(`/urls/${urlId}/rendering_config`, body);
  },

  deleteUrlConfig(urlId) {
    return ApiService.delete(`/urls/${urlId}/rendering_config`);
  },

  resolve(urlId) {
    return ApiService.get(`/rendering_resolve?url_id=${urlId}`);
  },

  listEngines(cacheKey) {
    const key = String(cacheKey || 'anonymous');
    const cached = engineCache.get(key);
    const cacheIsFresh = cached && Date.now() - cached.time < ENGINE_CACHE_TTL_MS;
    if (cacheIsFresh) {
      return Promise.resolve(cached.response);
    }
    if (engineRequests.has(key)) {
      return engineRequests.get(key);
    }

    const request = ApiService.get('/rendering_engines')
      .then((response) => {
        const engines = Array.isArray(response)
          ? response
          : (response && Array.isArray(response.data) && response.data) || [];
        const keyPolicy = (!Array.isArray(response) && response && response.key_policy) || null;
        const packed = { engines, key_policy: keyPolicy };
        engineCache.set(key, { response: packed, time: Date.now() });
        return packed;
      })
      .finally(() => {
        engineRequests.delete(key);
      });
    engineRequests.set(key, request);
    return request;
  },

  createEngine(body) {
    return ApiService.post('/rendering_engines', body).then((response) => {
      clearEngineCache();
      return response;
    });
  },

  updateEngine(engineCode, body) {
    return ApiService.put(`/rendering_engines/${encodeURIComponent(engineCode)}`, body).then(
      (response) => {
        clearEngineCache();
        return response;
      }
    );
  },

  deleteEngine(engineCode) {
    return ApiService.delete(`/rendering_engines/${encodeURIComponent(engineCode)}`).then(
      (response) => {
        clearEngineCache();
        return response;
      }
    );
  },
};

export default RenderingService;
